import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { Currency, DynamicExchangeRate } from '@emi/shared/models';
import { CountryEffects, getViaExchangeRates } from '@emi/shared/state/filters';
import { select, Store } from '@ngrx/store';
@Component({
    selector: 'via-ui-currency-dropdown',
    templateUrl: './currency-dropdown.component.html',
    styleUrls: ['./currency-dropdown.component.scss'],
})
export class CurrencyDropdownComponent implements OnInit {
    @Output()
    public currencyChange = new EventEmitter<string>();

    @Input()
    public dropdownDisabled: boolean;
    @Input()
    public selectedCurrency = 'USD';

    public currencyOpts: any[] = [];
    public currencyGroups: Currency[] = [];
    public defaultCurrencyGroups: Currency[] = [
        { currency: 'Local', currencyFullName: 'Local' },
        { currency: 'USD', currencyFullName: 'US dollar' },
        { currency: 'EUR', currencyFullName: 'Euro' },
        { currency: 'GBP', currencyFullName: 'British pound sterling' },
        { currency: 'JPY', currencyFullName: 'Japanese yen' },
        { currency: 'CHF', currencyFullName: 'Swiss franc' },
    ];

    constructor(private store: Store, private countryEffects: CountryEffects) { }

    public ngOnInit(): void {
        this.store.pipe(select(getViaExchangeRates)).subscribe((results) => {
            this.currencyOpts = [];
            this.currencyOpts.push(this.defaultCurrencyGroups);
            this.currencyGroups = [];

            let currencies = results.map((exchangeRate: DynamicExchangeRate) => new Currency(exchangeRate.toCurrencyName, exchangeRate.toCurrencyFullName));
            currencies = currencies.sort((a, b) => a?.currency?.localeCompare(b.currency));

            let uniqueCurrencies = this.removeDefaultCurrencies(currencies, this.defaultCurrencyGroups);

            uniqueCurrencies = this.removeDuplicates(uniqueCurrencies);
            const columnItemCount = this.getColumnItemCount(uniqueCurrencies.length);

            uniqueCurrencies.forEach((currency) => {
                this.currencyGroups.push(currency);

                if (this.currencyGroups.length === columnItemCount) {
                    this.currencyOpts.push(this.currencyGroups);
                    this.currencyGroups = [];
                }
            });

            if (this.currencyGroups.length > 0) {
                this.currencyOpts.push(this.currencyGroups);
            }
        });

    }

    private removeDuplicates(currencies: Currency[]) {
        return currencies.filter(
            (value, index, self) =>
                index === self.findIndex((s) => s.currency === value.currency)
        );
    }

    private removeDefaultCurrencies(currencies: Currency[], defaultCurrencies: Currency[]) {
        return currencies.filter(
            (currency) =>
                !defaultCurrencies.some(
                    (defaultCurrency) =>
                        currency.currency === defaultCurrency.currency
                )
        );
    }

    private getColumnItemCount(currenciesCount: number): number {
        // Ensures max of 4 columns of currencies in addition to default currencies column.
        if (currenciesCount > this.defaultCurrencyGroups.length * 4) {
            return Math.ceil(currenciesCount / 4);
        }
        return this.defaultCurrencyGroups.length;
    }

    public onCurrencyChange(event: MatSelectChange): void {
        this.currencyChange.emit(event.value);
    }

    public ngOnDestroy(): void {
        this.countryEffects.destroy$.next(false);
        this.countryEffects.destroy$.complete();
    }
}
